
























import Vue from "vue";
export default Vue.extend({
  name: "process",
  props: {
    process: Object,
  },
  computed: {
    importantWords(): any {
      return this.display("important_words");
    },
    patterns(): any {
      return this.display("patterns");
    },
    roots(): any {
      return this.display("roots");
    },
  },
  methods: {
    display(prop: string) {
      if (prop == "important_words") {
        const returnList1 = this.process[prop]["english"] as string[];
        const returnList12 = returnList1.join(", ");
        const returnList2 = this.process[prop]["hebrew"] as string[];
        const returnList22 = returnList2.join(", ");
        const returnList = { english: returnList12, hebrew: returnList22 };
        return returnList;
      } else {
        const list = this.process[prop] as string[];
        return list.join(", ");
      }
    },
  },
});
